import { TranslationKey } from './../../../../../../../types/translation/TranslationKey';

import React, { useContext, useMemo } from 'react';
import { ProductTransaction } from '../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../types/product_master_data/productMasterData';
import { Container } from '../../../../../../../types/container';
import ProductTransactionQuantity from './Common/ProductTransactionQuantity';
import TextInput from '../../../../../Common/TextInput';
import { t } from '../../../../../../../types/translation/Translator';
import { UserContext } from '../../../../../../../context/UserContext';
import DropdownSelect from '../../../../../Common/DropdownSelect';
import AssetCustomFields from './Common/AssetCustomFields';

interface ProcessOrderTransactionAssetBodyProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;

  userId?: string;
  setUserId: (userId?: string) => void;

  productMasterData: ProductMasterData;
  container?: Container;
  disabled?: boolean;
}

export default function ProcessOrderTransactionAssetBody({
  transaction,
  setTransaction,
  productMasterData,
  container,
  disabled = false,
  userId,
  setUserId,
}: ProcessOrderTransactionAssetBodyProps) {
  const { companyUsers } = useContext(UserContext);

  const userIds = useMemo(() => {
    return [...companyUsers.keys()];
  }, [companyUsers]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <DropdownSelect<string>
          label={t(TranslationKey.user).singular.label}
          disabled={disabled}
          placeholder={t(TranslationKey.selectUser).singular.label}
          values={userIds}
          selectedValue={userId || transaction.metadata?.assignedUser?.id || null}
          toText={id => {
            return companyUsers.get(id)?.email || '';
          }}
          onChange={id => {
            setUserId(id || undefined);
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextInput
          disabled={disabled}
          label={t(TranslationKey.serial).singular.label}
          placeholder={t(TranslationKey.serial).singular.label}
          value={transaction.product.serialNbr}
          onChange={serial => setTransaction(transaction => transaction.withSerial(serial))}
        />
      </Grid>
      <ProductTransactionQuantity
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
        container={container}
      />
      <AssetCustomFields
        transaction={transaction}
        setTransaction={setTransaction}
        productMasterData={productMasterData}
        disabled={disabled}
      />
    </Grid>
  );
}
